import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { DataService } from 'src/app/services/data/data.service';
import { DateService } from 'src/app/services/date/date.service';


@Component({
  selector: 'stock-edit',
  templateUrl: './stock-edit.component.html',
  styleUrls: ['./stock-edit.component.scss'],
})
export class StockEditComponent implements OnInit {
  @Input('item')
  set item (value:ProductModel){
    this._item = value;
    this.form.patchValue(this._item)
  }

  _item:ProductModel;

  @Input()
  tournee:TourneeModel;

  form: UntypedFormGroup;
  
  @Input()
  onSave = () => {};
  onCancel = () => {};

  parentTournee:TourneeModel;

  @Input()
  producer:ProfileModel;


  constructor(public route:ActivatedRoute, private dataService:DataService, private navParams: NavParams, 
    private navCtrl:NavController, private modalCtrl: ModalController, private dateService:DateService, public formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({
      stock: this.formBuilder.group({
        initial: [null, Validators.compose([Validators.required])],
        current: [null, Validators.compose([Validators.required])],
      })
    });    
  }

  ngOnInit() {
  }


  changeStock(value){
    if(!this._item.stock){
      this._item.stock = {
        initial: null,
        current: null
      }
    }
    this._item.stock.initial = value.stock.initial;
    this._item.stock.current = value.stock.current;
    if(value.current <= 0){
      this._item.stockStatus = 'outOfStock'
      delete this._item.stock;
    }
    this._item.stockStatus = value.stock.current <= 0?'outOfStock':'available';
    this.dataService.updateTourneeProductStock(this.tournee, this._item);
    this.onSave();
  }

  cancel(){
    if(this._item.stock.initial == null && this._item.stock.current == null){
      delete this._item.stock;
    }
    this.onCancel();
  }

  stopStock(){
    delete this._item.stock;
    this.onSave();
  }

  
}
